import { ReactNode } from 'react'
import { Menu } from '@highlight/ui'
import { MoreHorizontal } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

interface ToastOptionsProps {
  children: ReactNode
  triggerClassName?: string
}

export function ToastOptions({ children, triggerClassName }: ToastOptionsProps) {
  return (
    <Menu>
      <Menu.Trigger variant="ghost" shape="square" size="xs" className={twMerge('ml-auto shrink-0', triggerClassName)}>
        <MoreHorizontal />
      </Menu.Trigger>
      <Menu.Content positionerClassName="z-[901]">{children}</Menu.Content>
    </Menu>
  )
}
